import { render, staticRenderFns } from "./fansChange.vue?vue&type=template&id=895a01da&"
import script from "./fansChange.vue?vue&type=script&lang=js&"
export * from "./fansChange.vue?vue&type=script&lang=js&"
import style0 from "./fansChange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports